/* @ngInject */
function EmptyStateController ($scope) {
  const api = {
  }
  this.getApi = () => api

  $scope.onButtonClick = (event, button) => {
    if (button.pricing) {
      button.click(event)
    } else {
      button.click()
    }
  }
}

export { EmptyStateController }
